import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PLAN_STEPS, WITHOUT_PLAN } from '../../data/catio';

/** Problem + process in one compact story: guesswork vs. a five-step plan. */
export function PlanSection() {
  return <section aria-labelledby="plan-title" className="bg-ivory py-12 sm:py-20" data-id="element-246" data-mp="16xlqbd713x80">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-247" data-mp="1bv44pj3tf4ne">
        <SectionHeading id="plan-title" title="You Don’t Need More Catio Inspiration. You Need a Plan." data-id="element-248" data-mp="f5wdpvkfg3c3" />

        <div className="mt-8 grid gap-3 sm:mt-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-5" data-id="element-249" data-mp="j8jb0bzvaggo">
          <div className="flex flex-col rounded-[16px] border border-line bg-paper px-5 py-5 sm:px-7 sm:py-7" data-id="element-250" data-mp="o6cg11pfp4fd">
            <h3 className="label-tech text-graphite" data-id="element-251" data-mp="syclf9o9wpjc">Without a plan</h3>
            <p className="mt-3 font-display text-[2.5rem] leading-none text-ink/30 line-through decoration-ember decoration-2 sm:text-[3.2rem]" data-id="element-252" data-mp="3rnuonbd16fgu">
              Guess
            </p>
            <p className="mt-3 text-[0.98rem] leading-relaxed text-graphite" data-id="element-253" data-mp="210339f5ph95j">{WITHOUT_PLAN}</p>
          </div>

          <div className="rounded-[16px] bg-ink px-5 py-5 text-cream sm:px-7 sm:py-7" data-id="element-254" data-mp="1wyrch6b3ihvr">
            <h3 className="label-tech text-ember-light" data-id="element-255" data-mp="1s7st1xut93oa">With CATIO READY™</h3>
            <ol className="relative mt-4 grid gap-1 lg:mt-6 lg:grid-cols-5 lg:gap-4" data-id="element-256" data-mp="1s5ofeo740qat">
              <span className="absolute bottom-5 left-[15px] top-5 w-px bg-wood/50 lg:hidden" aria-hidden data-id="element-257" data-mp="1n8fuifuku85v" />
              {PLAN_STEPS.map((step, index) => <li key={step.title} className="relative flex items-center gap-4 py-1.5 lg:flex-col lg:items-start lg:gap-3 lg:py-0" data-id="element-258" data-mp="1d974tz6qvfpb" data-mpi={index}>
                  <span className="relative z-10 flex h-[31px] w-[31px] shrink-0 items-center justify-center rounded-full border border-ember-light bg-ink font-tech text-[14px] font-semibold text-ember-light" data-id="element-259" data-mp="14bepiv10w81x">
                    {index + 1}
                  </span>
                  <span data-id="element-260" data-mp="3hs7ycla4ns30">
                    <span className="block font-display text-[1.4rem] leading-none" data-id="element-261" data-mp="3hqww4pwbyse0">
                      {step.title}
                    </span>
                    <span className="mt-1 block text-[0.86rem] leading-snug text-cream/70" data-id="element-262" data-mp="38rrv9cxaqmyo">
                      {step.hint}
                    </span>
                  </span>
                </li>)}
            </ol>
          </div>
        </div>

        <p className="mt-8 text-center font-display text-[1.5rem] leading-tight text-ink sm:mt-10 sm:text-[2rem]" data-id="element-263" data-mp="5bkube69n3tl">
          <span className="border-b-2 border-ember pb-1" data-id="element-264" data-mp="9ak71ky8o4vl">The design work is already done.</span>
        </p>
      </div>
    </section>;
}